import {
  QuestionGroup,
  NewQuestionGroup,
} from "@stormwater-software/lib-inspection-templates";
import { useMutation, useQueryClient } from "react-query";
import { questionGroupApi } from "../utils/api/questionGroup";
import { pdfLayoutKey } from "./pdfLayout";

// create question group
export function useCreateQuestionGroup(inspectionTemplateId: number) {
  return useMutation((newQuestionGroup: NewQuestionGroup) => {
    return questionGroupApi.create(inspectionTemplateId, newQuestionGroup);
  });
}

// update question group name / layout / table headers
export function useUpdateQuestionGroup(inspectionTemplateId: number) {
  const queryClient = useQueryClient();

  return useMutation(
    (updatedQuestionGroup: QuestionGroup) => {
      if (updatedQuestionGroup.id) {
        return questionGroupApi.update(
          inspectionTemplateId,
          updatedQuestionGroup.id,
          updatedQuestionGroup,
        );
      } else {
        throw new Error("Question Group object must include ID");
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(pdfLayoutKey(inspectionTemplateId));
      },
    },
  );
}
